import { render, staticRenderFns } from "./Biodiversity.vue?vue&type=template&id=2d611a44&scoped=true&"
import script from "./Biodiversity.vue?vue&type=script&lang=js&"
export * from "./Biodiversity.vue?vue&type=script&lang=js&"
import style0 from "./Biodiversity.vue?vue&type=style&index=0&id=2d611a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d611a44",
  null
  
)

export default component.exports